import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { Divider } from "@material-ui/core";
import ElementIcon from "../element_icon";
import BackgroundPositionEditor from "./background_position_editor";

class Background extends Component {
  resetPosition = () => {
    const { config, updateConfig } = this.props;
    config.customization.background_width = 30;
    config.customization.background_height = 30;
    config.customization.background_position_x = 50;
    config.customization.background_position_y = 50;
    updateConfig(config);
  };

  render() {
    const { t, config, updateConfig, updateCustomization, uploading, updateIcon } = this.props;

    return (
      <div className="nlp-config">
        <div className={"cen_card"}>
          <div className={"content"}>
            <div className="elements_custom grid">
              <div className="elements_custom__info">
                <span className="elements_custom__title">
                  {t("card.content.project.web_interface.customization.background.image.title")}
                </span>
                <span className="elements_custom__description">
                  {t("card.content.project.web_interface.customization.background.image.description")}
                </span>
              </div>
              <ElementIcon
                updateIcon={updateIcon}
                updateCustomization={updateCustomization}
                element={"background"}
                img={config.background_icon || `${process.env.PUBLIC_URL}/background_widget.png`}
                icon_type={"background"}
                loading={uploading}
              />
            </div>
          </div>
          <Divider />
          <div className={"content"}>
            <div className="elements_custom grid">
              <div className="elements_custom__info">
                <span className="elements_custom__title">
                  {t("card.content.project.web_interface.customization.background.position.title")}
                </span>
                <span className="elements_custom__description">
                  {t("card.content.project.web_interface.customization.background.position.description")}
                </span>
                <span className="elements_custom__reset" onClick={this.resetPosition}>
                  {t("card.content.project.web_interface.customization.background.position.reset")}
                </span>
              </div>
              <BackgroundPositionEditor config={config} updateConfig={updateConfig} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state
  };
};

const a = connect(mapStateToProps)(Background);

export default withTranslation("common")(withRouter(a));
